import { motion } from 'framer-motion'
import { css, styled } from 'styled-components'

import { Logo as LogoCT } from 'components/icons/logo'
import { mq } from 'styles/mq'
import { focusable, resetButtonStyle } from 'styles/utils'

export const Nav = styled(motion.nav)`
  display: flex;
  align-items: center;
  flex-direction: column;
  position: sticky;
  width: 100%;
  height: var(--header-height);
  top: calc(3.2rem - 1 * var(--header-height));
  font-size: 1.6rem;
  color: var(--text-color);
  border-bottom: 1px solid var(--grey);
  text-align: center;
  background: var(--background);
  z-index: 2000;
`
export const LogoContainer = styled.a`
  ${focusable}
  display: block;
  width: max-content;
  margin: auto;
  color: inherit;
  overflow: hidden;

  &:hover,
  &:focus {
    color: inherit;
  }
`
export const Logo = styled(LogoCT)`
  display: block;
  width: auto;
  height: 4.7rem;

  ${mq.smallOnly} {
    height: 3.5rem;
  }
`

export const Menu = styled.ul`
  display: block;
  list-style: none;
  padding: 0 0 0.2em;
  margin: 0;

  ${mq.smallOnly} {
    width: 100%;
    white-space: nowrap;
    overflow: auto;
    scroll-snap-type: x proximity;
    scroll-behavior: smooth;
  }
`

export const MenuItem = styled.li<{ $isActive?: boolean }>`
  display: inline;
  padding-inline: 1em;
  scroll-snap-align: center;

  ${mq.large} {
    padding-inline: 1.5em;
  }

  ${props =>
    props.$isActive &&
    css`
      color: var(--primary-color);
    `}
`

export const MenuButton = styled.button`
  ${resetButtonStyle}

  &:not(:disabled) {
    cursor: pointer;
  }
`
